import { useTranslation } from "react-i18next";
import { Badge, type IBadgeProps } from "@components/Badge/Badge";
import { DotIcon } from "@components/icons";
import { Tooltip } from "@components/Tooltip/Tooltip";
import { BillState } from "@services/overview/types";

interface IProviderBillStatusBadgeProps {
  billState: BillState;
}

const badgeProps: Record<BillState, IBadgeProps> = {
  [BillState.Waiting]: {},
  [BillState.Ready]: {},
  [BillState.Paid]: { color: "green" },
  [BillState.Unpaid]: { color: "red" },
  [BillState.PartiallyPaid]: {
    color: "red",
  },
  [BillState.MustBeFilledByUser]: { color: "yellow" },
};

export const ProviderBillStatusBadge: React.FC<
  IProviderBillStatusBadgeProps
> = ({ billState }) => {
  const { t } = useTranslation();

  const description: Partial<Record<BillState, string>> = {
    [BillState.MustBeFilledByUser]: t(`bill.billStateDescription.${billState}`),
  };

  return (
    <Tooltip content={description[billState]}>
      <Badge
        {...badgeProps[billState]}
        size="small"
        variant="bubble"
        icon={DotIcon}
        iconClassName="size-2"
      >
        {t(`bill.billState.${billState}`)}
      </Badge>
    </Tooltip>
  );
};
